import React, {Component} from 'react';
const { withRouter } = require('react-router');
import queryString from 'query-string';

import {t, dt} from 'l10n';

import 'sass/headers/header.scss';

import MemberSearchForm from 'components/common/MemberSearchForm';
import paths from "../../paths";

class HeaderProfiles extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
        };
    }

    toggleShow() {
        let showStatus = this.state.show;
        (showStatus) ? this.setState({show:false}) : this.setState({show:true});
    }

    onFormSubmit(formData) {
        const {query} = formData;
        const {history, location} = this.props;
        const prefix = location.pathname.includes('/en') ? '/en' : '';
        history.push({
            pathname: prefix + paths.profiles.toPath({ query }),
            search: queryString.stringify(formData)
        });
    }

    render() {
        let {search} = this.props;

        const {show} = this.state;

        let classShow = "showblock";

        let textshow = t('Show more');

        if (show) {
            classShow = "showblock active";
            textshow = t('Hide more')
        }

        // todo: translation

        return (
            <header className="profiles">
                <div className="content">
                    <h1>{t('Profiles')}</h1>
                    <div className="text-subtitle">
                        <p>{t('The page BobTV members allows you to search all the profiles registered on the webcam chat')} <span className="showtoggle" onClick={(e) => {this.toggleShow()}}>{textshow}</span></p>
                        <div className={classShow} dangerouslySetInnerHTML={{__html: t('<p>You can discover the thousands of pages of profiles updated by members of webcam chat and quickly get into contact with them even if they are not in chat rooms at the moment.</p><p>You can find photo albums of all members, their friend lists, send them a message and even give them a virtual gift.</p><p>With this search tool you will certainly make new friends.</p>')}}/>
                    </div>

                    <MemberSearchForm onSubmit={(formData) => this.onFormSubmit(formData)} values={search}/>
                </div>
            </header>
        )
    }
}

export default withRouter(HeaderProfiles);


// WEBPACK FOOTER //
// ./src/components/profiles/HeaderProfiles.js